export class CredentialExpirationRule {
  canExpire: boolean;
  expirationOption: ExpirationOption;
  yearsUntilExpiration?: number;
  expirationDate?: string;
  hasMinimumLength: boolean;
  minimumDays?: number;
  customRenewalRule?: string;

  constructor(data?: Partial<CredentialExpirationRule>) {
    if (!data) {
      this.canExpire = false;
      this.expirationOption = ExpirationOption.YearsFromIssueDate; //dropdown gets angry if expirationOption isn't set
      return;
    }
    this.canExpire = data.canExpire;
    this.expirationOption = data.expirationOption;
    this.yearsUntilExpiration = data.yearsUntilExpiration;
    this.expirationDate = data.expirationDate;
    this.hasMinimumLength = data.hasMinimumLength;
    this.minimumDays = data.minimumDays;
    this.customRenewalRule = data.customRenewalRule;
  }
}

export enum ExpirationOption {
  YearsFromIssueDate = 'YearsFromIssueDate',
  EveryYearOnDate = 'EveryYearOnDate',
  OddYearsOnDate = 'OddYearsOnDate',
  EvenYearsOnDate = 'EvenYearsOnDate',
  CustomRule = 'CustomRule',
}

export const ExpirationOptionLabel = new Map<ExpirationOption, string>([
  [ExpirationOption.YearsFromIssueDate, 'Number of years from issue date'],
  [ExpirationOption.EveryYearOnDate, 'Every year starting on...'],
  [ExpirationOption.OddYearsOnDate, 'Odd years starting on...'],
  [ExpirationOption.EvenYearsOnDate, 'Even years starting on...'],
  [ExpirationOption.CustomRule, 'Custom Rule...'],
]);
